export default __webpack_public_path__ + "static/blob4-e9a7fbaeae03c2ee824374aaaabe957e.svg";